module.exports = __webpack_public_path__ + "assets/adc4535cd5d32dcc3b87a10a9b4728c6.mp3";